/* Konfigurator próbek - wydzielony z konfigurator-natywny.js (tryb sample_mode).
   Uproszczony flow: styl → kolor → wykończenie → add-to-cart (flat price, variant próbki).
   Payload properties MUSI być identyczny z buildSampleProperties() głównego konfiguratora
   (kompatybilność z produkcją Pro-Hand). Namespace: knfp / data-knfp-* (zero kolizji z .knf). */
(function () {
  "use strict";

  document.querySelectorAll("[data-knfp]").forEach(initKnfp);

  function initKnfp(root) {
    const cfg = {
      styles: JSON.parse(root.dataset.styles || '{"styles":[]}'),
      colors: JSON.parse(root.dataset.colors || "{}"),
      rules: JSON.parse(root.dataset.rules || '{"rules":{}}'),
    };

    // Kolejność kafelków stylów - IDENTYCZNA jak w konfiguratorze głównym (2026-07-30):
    // najpierw lakierowane, potem forniry, na końcu sklejki. Sortowanie stabilne, więc
    // wewnątrz grupy zostaje kolejność z metafieldu styles_config (wspólnego dla obu
    // konfiguratorów) - układanie stylów w Shopify Admin działa tu tak samo.
    (() => {
      const RANGA = { lakier: 0, fornir: 1, sklejka: 2 };
      const lista = (cfg.styles && cfg.styles.styles) || [];
      if (!Array.isArray(lista) || lista.length < 2) return;
      lista.forEach((s, i) => { s._kolejnosc = i; });
      lista.sort((a, b) => {
        const ra = RANGA[a.category] === undefined ? 3 : RANGA[a.category];
        const rb = RANGA[b.category] === undefined ? 3 : RANGA[b.category];
        return ra - rb || a._kolejnosc - b._kolejnosc;
      });
      lista.forEach(s => { delete s._kolejnosc; });
    })();
    const locale = (root.dataset.locale || "pl").toLowerCase().slice(0, 2);

    const $ = (sel, ctx = root) => ctx.querySelector(sel);
    const $$ = (sel, ctx = root) => Array.from(ctx.querySelectorAll(sel));

    // -- I18n helpers (kopiowane z konfigurator-natywny.js - pola *_en/_cs/_de w metafields)
    const t = (obj, key) => {
      if (!obj) return "";
      const localized = obj[`${key}_${locale}`];
      return localized || obj[key] || "";
    };
    function tStyle(plName) {
      if (locale === "pl") return plName;
      const list = (cfg && cfg.styles && cfg.styles.styles) || [];
      const found = list.find(s => s.name === plName);
      return (found && found[`name_${locale}`]) || plName;
    }
    function tColor(plName) {
      if (locale === "pl" || !plName) return plName;
      const palettes = Object.values((cfg && cfg.colors) || {});
      for (const p of palettes) {
        for (const c of (p.colors || [])) {
          if (c.name === plName) return c[`name_${locale}`] || c.name;
        }
      }
      return plName;
    }

    // -- Cart properties per locale - subset PROP_I18N. SYNC z konfigurator-natywny.js.
    const PROP_I18N = {
      pl: { K_FRONT_PROBKI: "Front próbki", K_WYK_PROBKI: "Wykończenie próbki", V_INNY: "Inny", V_POLMAT: "Półmat", V_POLYSK: "Połysk (+15%)", V_GRUBOSC: "Grubość" },
      en: { K_FRONT_PROBKI: "Sample front", K_WYK_PROBKI: "Sample finish", V_INNY: "Custom", V_POLMAT: "Semi-matt", V_POLYSK: "Gloss (+15%)", V_GRUBOSC: "Thickness" },
      cs: { K_FRONT_PROBKI: "Vzorek čela", K_WYK_PROBKI: "Povrchová úprava vzorku", V_INNY: "Jiný", V_POLMAT: "Polomatný", V_POLYSK: "Lesk (+15%)", V_GRUBOSC: "Tloušťka" },
      de: { K_FRONT_PROBKI: "Musterfront", K_WYK_PROBKI: "Musterausführung", V_INNY: "Sonder", V_POLMAT: "Halbmatt", V_POLYSK: "Hochglanz (+15%)", V_GRUBOSC: "Stärke" },
    };
    const L_PROP = PROP_I18N[locale] || PROP_I18N.pl;

    // Grubość frontu wg stylu (styles_config.thickness_mm, od 2026-07-24). SYNC z konfigurator-natywny.js.
    function styleThicknessMm(stylName) {
      const s = ((cfg && cfg.styles && cfg.styles.styles) || []).find(x => x.name === stylName);
      const th = s && Number(s.thickness_mm);
      return (Number.isFinite(th) && th > 0) ? th : null;
    }

    // Stan po dodaniu (2026-09-12): panel inline w .knfp__cta zamiast toastu (parytet z
    // konfigurator-natywny.js), pytanie o duplikat, błąd inline. Tylko zwykłe myślniki.
    const ADD_I18N = {
      pl: { ADDED: "Próbka dodana do koszyka", IN_CART: "w koszyku: {n} szt.", GO_CART: "Przejdź do koszyka", NEXT: "Dodaj kolejną próbkę", DUP_Q: "Ta próbka jest już w koszyku. Dodać drugą?", YES: "Tak, dodaj", NO: "Nie, zostaw", ERR: "Nie udało się dodać do koszyka.", RETRY: "Spróbuj ponownie", CHECKING: "Sprawdzam koszyk...", BTN_DONE: "Dodano ✓", ERR_BTN: "Błąd, spróbuj ponownie" },
      en: { ADDED: "Sample added to cart", IN_CART: "in cart: {n} pcs", GO_CART: "Go to cart", NEXT: "Add another sample", DUP_Q: "This sample is already in your cart. Add a second one?", YES: "Yes, add it", NO: "No, keep it", ERR: "Could not add to cart.", RETRY: "Try again", CHECKING: "Checking your cart...", BTN_DONE: "Added ✓", ERR_BTN: "Error, try again" },
      cs: { ADDED: "Vzorek přidán do košíku", IN_CART: "v košíku: {n} ks", GO_CART: "Přejít do košíku", NEXT: "Přidat další vzorek", DUP_Q: "Tento vzorek už je v košíku. Přidat druhý?", YES: "Ano, přidat", NO: "Ne, nechat", ERR: "Nepodařilo se přidat do košíku.", RETRY: "Zkusit znovu", CHECKING: "Kontroluji košík...", BTN_DONE: "Přidáno ✓", ERR_BTN: "Chyba, zkuste to znovu" },
      de: { ADDED: "Muster in den Warenkorb gelegt", IN_CART: "im Warenkorb: {n} Stk.", GO_CART: "Zum Warenkorb", NEXT: "Weiteres Muster hinzufügen", DUP_Q: "Dieses Muster liegt bereits im Warenkorb. Ein zweites hinzufügen?", YES: "Ja, hinzufügen", NO: "Nein, so lassen", ERR: "Konnte nicht in den Warenkorb gelegt werden.", RETRY: "Erneut versuchen", CHECKING: "Warenkorb wird geprüft...", BTN_DONE: "Hinzugefügt ✓", ERR_BTN: "Fehler, bitte erneut versuchen" },
    };
    const L_ADD = ADD_I18N[locale] || ADD_I18N.pl;
    // Prefiks locale (/en-eu/ itd.) - bez niego /cart/add.js odpowiada w domyślnym języku (PL)
    const CART_ROOT = window.Shopify?.routes?.root || "/";
    // Id sekcji z cart drawerem - SYNC z konfigurator-natywny.js (po migracji Horizon
    // drawer żyje w "cart-drawer-section", nie w "header").
    const DRAWER_SECTION_ID = (() => {
      const sec = document.querySelector("cart-drawer-component")?.closest(".shopify-section");
      return sec ? sec.id.replace(/^shopify-section-/, "") : "cart-drawer-section";
    })();

    const BTN_I18N = {
      pl: { ADDING: "Dodawanie…", MISS_STYL: "Wybierz styl frontu →", MISS_KOLOR: "Wybierz kolor →" },
      en: { ADDING: "Adding…", MISS_STYL: "Select front style →", MISS_KOLOR: "Select color →" },
      cs: { ADDING: "Přidávání…", MISS_STYL: "Vyberte styl čela →", MISS_KOLOR: "Vyberte barvu →" },
      de: { ADDING: "Wird hinzugefügt…", MISS_STYL: "Frontstil wählen →", MISS_KOLOR: "Farbe wählen →" },
    };
    const L_BTN = BTN_I18N[locale] || BTN_I18N.pl;

    // -- Stałe próbki. SYNC z konfigurator-natywny.js (SAMPLE_DIM_*, STYLES_WITH_GLOSS, BESTSELLER_STYLES).
    const SAMPLE_VARIANT_ID = root.dataset.sampleVariantId || "";
    // Cena z Liquid (money) - JUŻ w walucie rynku, nie konwertować w JS.
    const SAMPLE_PRICE_FMT = root.dataset.samplePriceFmt || "";
    // Liczbowo (szer/wys osobno) - string display wyliczany; liczby idą też do _szer_mm/_wys_mm dla Pro-Hand.
    const SAMPLE_DIMS_MM = { default: { szer: 284, wys: 396 }, "Gładki": { szer: 145, wys: 230 } };
    const sampleDims = (styl) => (styl && SAMPLE_DIMS_MM[styl]) || SAMPLE_DIMS_MM.default;
    const sampleDimMM = (styl) => { const d = sampleDims(styl); return `${d.szer} × ${d.wys} mm`; };
    // Tekst przycisku z Liquid (t_sample_add_btn per locale); fallback JS z kompletem de (luka naprawiona)
    // Fallback bez kwoty w obcych locale - hardkod "PLN" mylil klientow EUR (audyt 2026-08-04);
    // kwote w walucie rynku dokleja SAMPLE_PRICE_FMT (money z Liquid), gdy jest dostepna.
    const SAMPLE_ADD_BTN_TEXT = root.dataset.tSampleAddBtn || ((
      locale === "en" ? "Add sample" :
      locale === "cs" ? "Přidat vzorek" :
      locale === "de" ? "Muster hinzufügen" :
      "Dodaj próbkę"
    ) + (SAMPLE_PRICE_FMT ? ` · ${SAMPLE_PRICE_FMT}` : (locale === "pl" || !locale ? " · 89 zł" : "")));
    // Połysk tylko dla gładkich powierzchni + Round Oak; frezowane → tylko Półmat (frez ginie w połysku)
    // Style z możliwym połyskiem - czytane Z METAFIELDU conditional_rules, nie z listy w kodzie.
    // Powód (2026-07-30): lista była wpisana na sztywno i rozjechała się z konfiguratorem głównym.
    // Próbki oferowały połysk dla Round i Round Oak, a tych frontów w połysku NIE DA SIĘ kupić
    // (nie mają opcji `polysk_polmat` w regułach) - klient mógł zamówić próbkę wykończenia,
    // którego potem nie kupi. Teraz oba konfiguratory czytają to samo źródło: dopisanie
    // `polysk_polmat` do reguł stylu włącza połysk równocześnie tutaj i w konfiguratorze frontów.
    // Fallback na starą listę tylko wtedy, gdy metafieldu reguł zabraknie.
    const STYLES_WITH_GLOSS = (() => {
      const rules = (cfg.rules && cfg.rules.rules) || {};
      const zRegul = Object.keys(rules).filter(name => (rules[name].options || []).includes("polysk_polmat"));
      return zRegul.length
        ? new Set(zRegul)
        : new Set(["Gładki", "Grip", "Round", "Round Oak", "Frezowany uchwyt"]);
    })();
    const BESTSELLER_STYLES = new Set(["Gładki"]);

    const state = { styl: null, kolor: null, custom_kolor: null };

    function escapeHtml(s) {
      return String(s ?? "").replace(/[&<>"']/g, m => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]));
    }
    function escapeAttr(s) { return escapeHtml(s); }

    // -- 1. Grid stylów (bez ceny/m² - dla próbki flat price)
    function renderStyles() {
      const wrap = $("[data-knfp-styles]");
      wrap.innerHTML = cfg.styles.styles.map(s => {
        const displayName = t(s, "name");
        const displayHelp = t(s, "helptext") || displayName;
        const badgeLabel = s.badge || (BESTSELLER_STYLES.has(s.name) ? "BESTSELLER" : "");
        const isBestseller = !!badgeLabel;
        return `
        <button type="button" class="knfp__style${isBestseller ? ' knfp__style--bestseller' : ''}" data-style="${escapeAttr(s.name)}" data-category="${s.category}" role="radio" aria-checked="false" aria-label="${escapeAttr(displayName + ' - ' + displayHelp + (isBestseller ? ' (' + badgeLabel.toLowerCase() + ')' : ''))}" title="${escapeAttr(displayHelp)}">
          ${isBestseller ? `<span class="knfp__style-badge" aria-hidden="true">${escapeHtml(badgeLabel)}</span>` : ''}
          ${s.swatch_url ? `<img class="knfp__style-img" src="${escapeAttr(s.swatch_url)}" alt="${escapeAttr(displayName)}" loading="lazy">` : `<span class="knfp__style-img knfp__style-img--placeholder"></span>`}
          <span class="knfp__style-name" translate="no">${escapeHtml(displayName)}</span>
        </button>
      `;}).join("");

      wrap.addEventListener("click", e => {
        const btn = e.target.closest(".knfp__style");
        if (!btn) return;
        $$(".knfp__style", wrap).forEach(b => {
          b.classList.remove("is-active");
          b.setAttribute("aria-checked", "false");
        });
        btn.classList.add("is-active");
        btn.setAttribute("aria-checked", "true");
        state.styl = btn.dataset.style;
        onStyleChange();
      });
    }

    // -- 2. Styl → paleta kolorów + wykończenie + wymiar próbki
    function onStyleChange() {
      const styleObj = cfg.styles.styles.find(s => s.name === state.styl);
      if (!styleObj) return;
      const info = $("[data-knfp-style-info]");
      if (info) info.textContent = t(styleObj, "helptext") || "";
      // Zachowaj custom kolor przy zmianie stylu (klient wpisał F&B, zmienia styl - kolor zostaje)
      const prevCustomKolor = state.custom_kolor;
      state.kolor = null;
      $("[data-knfp-kolor-out]").value = "";
      renderColors(styleObj.category);
      const customBtn = $(".knfp__color--custom");
      if (prevCustomKolor && customBtn) {
        customBtn.click();
        const customInp = $("[data-knfp-kolor-custom]");
        if (customInp) {
          customInp.value = prevCustomKolor;
          customInp.dispatchEvent(new Event("input"));
        }
      } else {
        // Auto-pick pierwszego koloru gdy paleta ma chips (parytet z głównym konfiguratorem)
        const firstColorBtn = $(".knfp__color:not(.knfp__color--custom)");
        if (firstColorBtn) firstColorBtn.click();
      }
      updateSampleFinishOptions(styleObj.name);
      refreshSampleDim();
      update();
    }

    // -- 3. Paleta kolorów per kategoria stylu (lakier → chips + custom; fornir/sklejka → label)
    let activePaletteColors = null; // kolory aktualnej palety - źródło dla karty podglądu koloru
    function renderColors(category) {
      const wrap = $("[data-knfp-colors]");
      const customWrap = $("[data-knfp-custom-color]");
      const palette = cfg.colors[category];
      activePaletteColors = (palette && palette.colors) || null;
      hideColorDetail();

      // Park customWrap POZA wrap zanim wyczyścimy innerHTML - inaczej zginie przy re-renderze
      if (customWrap && customWrap.parentElement === wrap) {
        const fs = wrap.closest(".knfp__fs") || wrap.parentElement;
        if (fs) fs.appendChild(customWrap);
      }

      const inlineSpan = $("[data-knfp-kolor-inline]");
      const NO_PALETTE_MSG = { en: "Color follows from selected style", cs: "Barva vyplývá z vybraného stylu", de: "Farbe ergibt sich aus dem gewählten Stil", pl: "Kolor wynika z wybranego stylu" };
      if (!palette || (!palette.colors.length && !palette.custom_color_field)) {
        const lbl = (palette && t(palette, "label")) || NO_PALETTE_MSG[locale] || NO_PALETTE_MSG.pl;
        const sub = palette ? t(palette, "subtitle") : "";
        if (inlineSpan) {
          inlineSpan.innerHTML = `<span class="knfp__legend-inline-sep">·</span><span class="knfp__legend-inline-text">${escapeHtml(lbl)}</span>`;
          if (sub) inlineSpan.title = sub;
          inlineSpan.hidden = false;
        }
        wrap.innerHTML = "";
        wrap.style.display = "none";
        if (customWrap) customWrap.hidden = true;
        $("[data-knfp-kolor-out]").value = lbl;
        return;
      }
      if (inlineSpan) { inlineSpan.innerHTML = ""; inlineSpan.hidden = true; }
      wrap.style.display = "";

      wrap.innerHTML = palette.colors.map(c => {
        const cName = t(c, "name");
        const cHelp = t(c, "helptext");
        return `
        <button type="button" class="knfp__color" data-color="${escapeAttr(c.name)}" style="--kclr: ${escapeAttr(c.hex)}" role="radio" aria-checked="false" aria-label="${escapeAttr(cName + (cHelp ? ' - ' + cHelp : ''))}" title="${escapeAttr(cHelp || cName)}">
          <span class="knfp__color-swatch"></span>
          <span class="knfp__color-text">
            <span class="knfp__color-name">${escapeHtml(cName)}</span>
            ${cHelp ? `<span class="knfp__color-help">${escapeHtml(cHelp)}</span>` : ''}
          </span>
        </button>
      `;}).join("");

      if (palette.custom_color_field) {
        const OTHER_COLOR = { en: "Any color", cs: "Libovolná barva", de: "Beliebige Farbe", pl: "Dowolny kolor" };
        const targetLbl = OTHER_COLOR[locale] || OTHER_COLOR.pl;
        let customLbl = t(palette, "custom_color_label") || targetLbl;
        // Lokalny override do czasu update metafieldu custom.colors_palette (SYNC z konfigurator-natywny.js)
        customLbl = customLbl
          .replace(/\bnazwę i kod\b/i, 'nazwę lub kod')
          .replace('NCS / Farrow', 'NCS / ICA / Farrow')
          .replace('NCS, Farrow', 'NCS, ICA, Farrow')
          .replace(/^Inny kolor\b/, targetLbl)
          .replace(/^Other color\b/i, OTHER_COLOR.en)
          .replace(/^Jiná barva\b/i, OTHER_COLOR.cs);
        wrap.insertAdjacentHTML("afterbegin", `
          <button type="button" class="knfp__color knfp__color--custom" data-color="__custom__">
            <span class="knfp__color-swatch knfp__color-swatch--custom">+</span>
            <span class="knfp__color-name">${escapeHtml(customLbl)}</span>
            <span class="knfp__color-badge">BESTSELLER</span>
          </button>
        `);
        const customBtn = wrap.querySelector(".knfp__color--custom");
        if (customBtn && customWrap) customBtn.after(customWrap);
      }

      wrap.addEventListener("click", onColorPick);
    }

    function onColorPick(e) {
      const btn = e.target.closest(".knfp__color");
      if (!btn) return;
      $$(".knfp__color").forEach(b => {
        b.classList.remove("is-active");
        b.setAttribute("aria-checked", "false");
      });
      btn.classList.add("is-active");
      btn.setAttribute("aria-checked", "true");

      const customWrap = $("[data-knfp-custom-color]");
      if (btn.dataset.color === "__custom__") {
        hideColorDetail();
        customWrap.hidden = false;
        const customInput = $("[data-knfp-kolor-custom]");
        $("[data-knfp-kolor-out]").value = customInput.value || "";
        state.kolor = null;
        update();
        customInput.focus();
        customInput.addEventListener("input", () => {
          state.custom_kolor = customInput.value;
          $("[data-knfp-kolor-out]").value = customInput.value;
          update();
        });
      } else {
        customWrap.hidden = true;
        state.kolor = btn.dataset.color;
        $("[data-knfp-kolor-out]").value = btn.dataset.color;
        renderColorDetail(btn.dataset.color);
        update();
      }
    }

    // Karta podglądu koloru pod paletą - duży swatch + pochodzenie (Farrow & Ball / NCS) + opis.
    // Parytet z konfiguratorem głównym (renderColorDetail w konfigurator-natywny.js).
    // Dane z metafieldu colors_palette: hex, origin, badge (BODBYN), helptext.
    function renderColorDetail(colorName) {
      const wrap = $("[data-knfp-colors]");
      if (!wrap) return;
      let card = $("[data-knfp-color-detail]");
      if (!card) {
        card = document.createElement("div");
        card.className = "knfp__color-detail";
        card.setAttribute("data-knfp-color-detail", "");
        wrap.after(card);
      }
      const c = activePaletteColors && activePaletteColors.find(x => x.name === colorName);
      if (!c) { card.hidden = true; return; }
      const badge = c.badge ? `<span class="knfp__color-detail-badge">${escapeHtml(t(c, "badge"))}</span>` : "";
      const origin = c.origin ? `<span class="knfp__color-detail-origin">${escapeHtml(c.origin)}</span>` : "";
      const help = t(c, "helptext") ? `<span class="knfp__color-detail-help">${escapeHtml(t(c, "helptext"))}</span>` : "";
      card.innerHTML = `
        <span class="knfp__color-detail-swatch" style="--kclr: ${escapeAttr(c.hex)}" aria-hidden="true"></span>
        <span class="knfp__color-detail-body">
          <strong class="knfp__color-detail-name">${escapeHtml(t(c, "name"))}${badge}</strong>
          ${origin}
          ${help}
        </span>`;
      card.hidden = false;
    }
    function hideColorDetail() {
      const card = $("[data-knfp-color-detail]");
      if (card) card.hidden = true;
    }

    // -- 4. Wykończenie: Połysk tylko dla STYLES_WITH_GLOSS
    function updateSampleFinishOptions(styleName) {
      const glossLabel = $('[data-knfp-fs-finish] input[value="Połysk"]')?.closest("label");
      if (!glossLabel) return;
      const hasGloss = STYLES_WITH_GLOSS.has(styleName);
      glossLabel.hidden = !hasGloss;
      if (!hasGloss) {
        const halfmat = $('[data-knfp-fs-finish] input[value="Pół-mat"]');
        if (halfmat) halfmat.checked = true;
      }
    }

    // -- 5. Wymiar próbki wg stylu (display only - do payloadu idzie przez buildSampleProperties)
    function refreshSampleDim() {
      const dim = sampleDimMM(state.styl);
      $$("[data-knfp-dim-value]").forEach(el => { el.textContent = dim; });
    }

    function canAdd() {
      if (!state.styl) return false;
      if (!$("[data-knfp-kolor-out]").value) return false;
      if (!SAMPLE_VARIANT_ID) return false;
      return true;
    }

    // Submit button: enabled/disabled + tekst brakującego kroku
    function update() {
      syncAdded();
      const btn = $("[data-knfp-submit]");
      if (!btn || isAddBusy()) return;
      if (canAdd()) {
        btn.disabled = false;
        btn.textContent = SAMPLE_ADD_BTN_TEXT;
        btn.classList.remove("knfp__btn--incomplete");
      } else {
        btn.disabled = false;
        btn.textContent = !state.styl ? L_BTN.MISS_STYL : L_BTN.MISS_KOLOR;
        btn.classList.add("knfp__btn--incomplete");
      }
    }

    function scrollToFirstMissing() {
      const target = !state.styl ? $("[data-knfp-styles]") : $("[data-knfp-colors]");
      if (!target) return;
      const fs = target.closest(".knfp__fs") || target;
      fs.classList.remove("knfp__error-flash");
      void fs.offsetWidth;
      fs.classList.add("knfp__error-flash");
      fs.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    // -- 6. Properties próbki. VERBATIM z konfigurator-natywny.js buildSampleProperties()
    //    (kompatybilność payloadu z produkcją Pro-Hand - NIE zmieniać struktury).
    function buildSampleProperties() {
      const props = {};
      const colorOut = $("[data-knfp-kolor-out]")?.value || "";
      const colorCustom = $("[data-knfp-kolor-custom]")?.value || "";
      const finishEl = $("[data-knfp-sample-finish]:checked");
      const finishPl = finishEl ? finishEl.value : "Półmat"; // "Pół-mat"/"Połysk"

      // 2 linijki dla próbki (translated keys + values per locale):
      // 1. "{K_FRONT_PROBKI}" = "{wymiar} · {styl} · {kolor}" (lub "{V_INNY}: NCS …")
      // 2. "{K_WYK_PROBKI}" = "{V_POLMAT}" / "{V_POLYSK}" (bez +15% bo dla próbki nieaplikowalne)
      const stylTr = state.styl ? tStyle(state.styl) : "";
      let kolorTr = tColor(colorOut);
      if (colorCustom && colorCustom.trim() && colorCustom !== colorOut) {
        kolorTr = `${L_PROP.V_INNY}: ${colorCustom.trim()}`;
      }
      const finishTr = /połysk/i.test(finishPl)
        ? L_PROP.V_POLYSK.replace(/\s*\(\+15%\)/, "")
        : L_PROP.V_POLMAT;

      const gr = styleThicknessMm(state.styl);
      const parts = [sampleDimMM(state.styl)];
      if (stylTr) parts.push(stylTr);
      if (kolorTr) parts.push(kolorTr);
      props[L_PROP.K_FRONT_PROBKI] = parts.join(" · ");
      props[L_PROP.K_WYK_PROBKI] = gr ? `${finishTr} · ${L_PROP.V_GRUBOSC}: ${gr} mm` : finishTr;

      // Strukturalne pola dla Pro-Hand (prefix "_" → ukryte w koszyku/checkout)
      const sd = sampleDims(state.styl);
      props["_wys_mm"] = String(sd.wys);
      props["_szer_mm"] = String(sd.szer);
      if (gr) props["_grubosc_mm"] = String(gr);

      // PL fallback dla Pro-Hand - ZAWSZE (też locale pl) + self-labeled (templatka Order Printer)
      {
        const plParts = [sampleDimMM(state.styl)];
        if (state.styl) plParts.push(state.styl);
        const kolorPl = (colorCustom && colorCustom.trim() && colorCustom !== colorOut)
          ? `Inny: ${colorCustom.trim()}` : colorOut;
        if (kolorPl) plParts.push(kolorPl);
        const wykPl = gr ? `${finishPl} · Grubość: ${gr} mm` : finishPl;
        props["_pl_summary"] = `Front próbki: ${plParts.join(" · ")} | Wykończenie próbki: ${wykPl}`;
      }
      return props;
    }

    // -- 7. Dodawanie do koszyka (2026-09-12): jeden performAdd() z blokadą knfSubmitting,
    //    panel [data-knfp-added] zamiast toastu, pytanie o duplikat, błąd inline z ponowieniem.
    //    Szuflada/licznik przez most window.knfCart (knf-cart-bridge.js, natywne zdarzenie
    //    Horizona) - bez ręcznego innerHTML, bez nieistniejącego cart-drawer-component.open().
    let addedKey = null, btnHold = false, doneTimer = null, pendingRetry = null;
    const bridge = () => window.knfCart || null;
    const cfgKey = () => JSON.stringify(buildSampleProperties());

    function isAddBusy() {
      const form = $("[data-knfp-form]");
      return btnHold || !!(form && (form.dataset.knfSubmitting === "1" || form.dataset.knfConfirming === "1"));
    }
    function hidePanel(name) { const p = $(`[data-knfp-${name}]`); if (p) p.hidden = true; }
    function hideAllPanels() { ["added", "dup", "error"].forEach(hidePanel); addedKey = null; }
    function syncAdded() { if (addedKey && addedKey !== cfgKey()) { hidePanel("added"); addedKey = null; } }
    function setAddedCount(n) {
      const el = $("[data-knfp-added-count]");
      if (el) el.textContent = (n != null && n > 0) ? "· " + L_ADD.IN_CART.replace("{n}", n) : "";
    }
    function showAdded(count) {
      hidePanel("dup"); hidePanel("error");
      addedKey = cfgKey();
      const label = $("[data-knfp-added-label]");
      if (label) label.textContent = [state.styl ? tStyle(state.styl) : "", sampleDimMM(state.styl)].filter(Boolean).join(" · ");
      setAddedCount(count);
      const p = $("[data-knfp-added]");
      if (p) p.hidden = false;
      const btn = $("[data-knfp-submit]");
      if (btn) { btn.disabled = false; btn.classList.remove("knfp__btn--incomplete"); btn.classList.add("knfp__btn--done"); btn.textContent = L_ADD.BTN_DONE; }
      btnHold = true;
      clearTimeout(doneTimer);
      doneTimer = setTimeout(() => { btnHold = false; if (btn) btn.classList.remove("knfp__btn--done"); update(); }, 2000);
    }
    function confirmDup() {
      const form = $("[data-knfp-form]");
      const p = $("[data-knfp-dup]");
      const yes = $("[data-knfp-dup-yes]");
      const no = $("[data-knfp-dup-no]");
      if (!form || !p || !yes || !no) return Promise.resolve(true);
      return new Promise(resolve => {
        hideAllPanels();
        form.dataset.knfConfirming = "1";
        p.hidden = false;
        const done = (answer) => {
          yes.removeEventListener("click", onYes); no.removeEventListener("click", onNo);
          p.hidden = true; delete form.dataset.knfConfirming; resolve(answer);
        };
        const onYes = () => done(true);
        const onNo = () => done(false);
        yes.addEventListener("click", onYes); no.addEventListener("click", onNo);
        try { no.focus({ preventScroll: true }); } catch (_) { /* stare Safari */ }
      });
    }
    function showError(message) {
      hidePanel("added"); hidePanel("dup"); addedKey = null;
      const msg = $("[data-knfp-error-msg]");
      if (msg) msg.textContent = message || L_ADD.ERR;
      const retry = $("[data-knfp-error-retry]");
      if (retry) { retry.disabled = false; retry.textContent = L_ADD.RETRY; }
      const p = $("[data-knfp-error]");
      if (p) p.hidden = false;
    }

    // Minimalny payload: variant próbki + properties z buildSampleProperties()
    function buildFormData() {
      const formData = new FormData();
      formData.set("id", SAMPLE_VARIANT_ID);
      formData.set("quantity", "1");
      const sampleProps = buildSampleProperties();
      for (const [k, v] of Object.entries(sampleProps)) {
        if (v != null && String(v).trim() !== "") formData.set(`properties[${k}]`, v);
      }
      return formData;
    }

    async function performAdd(form, formData, opts) {
      opts = opts || {};
      const b = bridge();
      const submitBtn = $("[data-knfp-submit]");
      const cfgHash = b ? b.buildConfigHash(formData) : null;
      let qtyBefore = opts.qtyBefore || 0;
      form.dataset.knfSubmitting = "1";
      submitBtn.disabled = true;
      submitBtn.textContent = L_BTN.ADDING;
      submitBtn.classList.remove("knfp__btn--incomplete");
      hidePanel("error");

      // 1. Identyczna próbka już w koszyku -> pytanie (klient może potwierdzić)
      if (b && !opts.skipDupCheck) {
        const cartBefore = await b.fetchCartSafe(1500);
        const line = cartBefore ? b.findLineByHash(cartBefore, cfgHash) : null;
        if (line) {
          qtyBefore = line.quantity;
          delete form.dataset.knfSubmitting;
          submitBtn.disabled = false;
          submitBtn.textContent = SAMPLE_ADD_BTN_TEXT;
          const ok = await confirmDup();
          if (!ok) { update(); return false; }
          return performAdd(form, formData, { skipDupCheck: true, qtyBefore });
        }
      }

      // 2. /cart/add.js: jedyne miejsce, które może pokazać błąd
      let data;
      try {
        if (b) { formData.set("sections", b.sectionId); formData.set("sections_url", window.location.pathname); }
        const r = await fetch(`${CART_ROOT}cart/add.js`, { method: "POST", body: formData, headers: { Accept: "application/json" } });
        let body = null;
        try { body = await r.json(); } catch (_) { /* nie-JSON */ }
        if (!r.ok || !body || body.status) {
          const err = new Error(`status_${r.status}`);
          err.description = body ? (body.description || body.message || "") : "";
          throw err;
        }
        data = body;
      } catch (err) {
        console.error("[knfp] sample add failed", err);
        delete form.dataset.knfSubmitting;
        pendingRetry = { formData, cfgHash, qtyBefore };
        showError(err.description || L_ADD.ERR);
        submitBtn.disabled = false;
        submitBtn.textContent = L_ADD.ERR_BTN;
        setTimeout(() => { if (!isAddBusy()) update(); }, 2000);
        return false;
      }

      // 3. Sukces: od tego miejsca nic nie pokazuje błędu
      delete form.dataset.knfSubmitting;
      pendingRetry = null;
      showAdded(qtyBefore + 1);
      if (b) {
        const cart = await b.afterAdd(form, { variantId: SAMPLE_VARIANT_ID, qty: 1, sections: data && data.sections });
        const line = cart ? b.findLineByHash(cart, cfgHash) : null;
        if (line) setAddedCount(line.quantity);
      }
      return true;
    }

    // "Spróbuj ponownie": najpierw /cart.js; jeśli linia urosła, sukces bez drugiego POST
    async function verifyThenRetry(form) {
      const p = pendingRetry;
      const b = bridge();
      if (!p || isAddBusy()) return;
      const retryBtn = $("[data-knfp-error-retry]");
      const msg = $("[data-knfp-error-msg]");
      if (retryBtn) retryBtn.disabled = true;
      if (msg) msg.textContent = L_ADD.CHECKING;
      const cart = b ? await b.fetchCartSafe(2500) : null;
      const line = cart ? b.findLineByHash(cart, p.cfgHash) : null;
      if (retryBtn) retryBtn.disabled = false;
      if (line && line.quantity > p.qtyBefore) {
        pendingRetry = null;
        hidePanel("error");
        showAdded(line.quantity);
        await b.afterAdd(form, { variantId: SAMPLE_VARIANT_ID, qty: 1, sections: null });
        return;
      }
      hidePanel("error");
      await performAdd(form, p.formData, { skipDupCheck: true, qtyBefore: p.qtyBefore });
    }

    // -- 8. Submit: blokada na czas dodawania i pytania (drugie tapnięcie = nic)
    function bindSubmit() {
      const form = $("[data-knfp-form]");
      form.addEventListener("submit", async e => {
        e.preventDefault();
        if (form.dataset.knfSubmitting === "1" || form.dataset.knfConfirming === "1") return;
        if (!canAdd()) {
          scrollToFirstMissing();
          return;
        }
        await performAdd(form, buildFormData(), {});
      });
      // Enter w polu koloru własnego nie wysyła formularza (implicit submission na telefonie)
      form.addEventListener("keydown", e => {
        if (e.key !== "Enter" || !(e.target instanceof HTMLInputElement) || e.target.type === "submit") return;
        e.preventDefault();
        e.target.blur();
      });
      const goCart = $("[data-knfp-added-cart]");
      if (goCart) goCart.textContent = L_ADD.GO_CART;
      const next = $("[data-knfp-added-next]");
      if (next) {
        next.textContent = L_ADD.NEXT;
        next.addEventListener("click", () => { hidePanel("added"); addedKey = null; const t = $("[data-knfp-styles]"); if (t) t.scrollIntoView({ behavior: "smooth", block: "start" }); });
      }
      const q = $("[data-knfp-dup-q]"); if (q) q.textContent = L_ADD.DUP_Q;
      const yes = $("[data-knfp-dup-yes]"); if (yes) yes.textContent = L_ADD.YES;
      const no = $("[data-knfp-dup-no]"); if (no) no.textContent = L_ADD.NO;
      const retry = $("[data-knfp-error-retry]");
      if (retry) { retry.textContent = L_ADD.RETRY; retry.addEventListener("click", () => { verifyThenRetry(form); }); }
      form.addEventListener("input", syncAdded);
      form.addEventListener("change", syncAdded);
    }

    // -- Boot: style → preselekcja bestsellera → bind
    renderStyles();
    const firstStyle = $(".knfp__style--bestseller") || $(".knfp__style");
    if (firstStyle) firstStyle.click();
    refreshSampleDim();
    bindSubmit();
    update();
  }
})();
